<template >
  <div>
    <InnerHeader />
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-12">
          <div class="row align-items-center mb-4">
            <div class="col-md-6">
                <h2 class="page-title mb-md-0 mb-3"><a href="javascript:void(0)"><img src="images/back-arrow.svg" width="20" alt="" class="me-2"></a> Viewed Contacts</h2>
            </div>
            <div class="col-md-6 text-end">
                 <button
                    type="button"
                    class="btn btn-brand-1 px-4"
                    data-bs-toggle="modal"
                    data-bs-target="#ViewContact"
                  >
                    <i class="fa fa-download font-20 me-2" aria-hidden="true"></i>
                    Download
                  </button>
            </div>
          </div>
           <div class="row align-items-center mb-2">
            <div class="col-lg-7">
            <ul
            class="nav nav-pills mb-3 tab-style-1 "
            id="login-tab"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <a
                class="nav-link active"
                id="email-tab"
                data-bs-toggle="pill"
                href="#tab_1"
                role="tab"
                aria-controls="tab_1"
                aria-selected="true"
                >Contacts i viewed</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link"
                id="phone-tab"
                data-bs-toggle="pill"
                href="#tab_2"
                role="tab"
                aria-controls="tab_2"
                aria-selected="false"
                >viewed my contacts (9)</a
              >
            </li>
          </ul>
           </div>
          </div>
           <div class="tab-content form-style border-top border-bottom pt-4">
            <div
              class="tab-pane fade show active"
              id="tab_1"
              role="tabpanel"
              aria-labelledby=""
            >
            <div class="row">
            <div class="col-lg-3 col-md-4 mb-4 position-relative">
                  <div
                    id="ProfileSlider"
                    class="carousel slide profile-sider"
                    data-bs-ride="carousel" data-bs-interval="false"
                  >
                    <div class="carousel-inner rounded-l cursor-pointer"  data-bs-toggle="modal" data-bs-target="#photosModal">
                      <div class="carousel-item active">
                        <img
                          src="images/profile-female-7.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-2.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-3.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                    </div>
                    <button
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#ProfileSlider"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#ProfileSlider"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                  <div class="text-center my-3 carousel-counter" id="slide-counter">
                    <div class="num text-white"></div>
                  </div>
                 
                </div>
                <div class="col-lg-7 col-md-8">
                  <div class="row">
                    <div class="col-lg-6">
                        <div class="row">
                          <div class="col-6"><label for="">Registration No.</label></div>
                          <div class="col-6"><p class="font-medium">S091293821</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Surname</label></div>
                          <div class="col-6"><p class="font-medium">Shinde</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Date of Birth</label></div>
                          <div class="col-6"><p class="font-medium">11/12/1991</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Height</label></div>
                          <div class="col-6"><p class="font-medium">5’ 2”</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Education</label></div>
                          <div class="col-6"><p class="font-medium">M.COM</p></div>
                        </div>
                        
                    </div>
                    <div class="col-lg-6">
                        <div class="row">
                          <div class="col-6"><label for="">Occupation</label></div>
                          <div class="col-6"><p class="font-medium">Business</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Annual Income (Lakh)</label></div>
                          <div class="col-6"><p class="font-medium">50 Lakh</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Working city</label></div>
                          <div class="col-6"><p class="font-medium"> Pune</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Native Place</label></div>
                          <div class="col-6"><p class="font-medium"> Pune</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Gun Milan</label></div>
                          <div class="col-6"><p class="font-medium">24</p></div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-4 ps-md-0">
                  <button
                    type="button"
                    class="btn btn-outline-brand-1 mb-3 w-100 px-2"
                    data-bs-toggle="modal"
                    data-bs-target="#ViewContact"
                  >
                    <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                    View Contact
                  </button>
                 
                  <div class="btn-group w-100" role="group" aria-label="Basic checkbox toggle button group">
                    <input type="checkbox" class="btn-check" id="btncheck1" autocomplete="off">
                    <label class="btn btn-outline-brand-1 mb-3 w-100" for="btncheck1"><i class="fa fa-heart font-20 me-2" aria-hidden="true"></i> Shortlist</label>
                  </div>
                  <button type="button" class="btn btn-brand-1 w-100 mb-3">
                    <i
                      class="fa fa-paper-plane font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    Send interest
                  </button>
                  
                  <div class="dropdown">
                  <button type="button" class="btn btn-outline-brand-1 w-100 dropdown-toggle" id="dropdownMore"  data-bs-toggle="dropdown" aria-expanded="false">
                    <i
                      class="fa fa-ellipsis-v font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    More
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMore">
                    <li><a class="dropdown-item" href="#"><i class="fa fa-share-alt" aria-hidden="true"></i> Share Profile</a></li>
                    <li><a class="dropdown-item" href="#"><i class="fa fa-ban" aria-hidden="true"></i> Block User</a></li>
                    <li><a class="dropdown-item" href="#"><i class="fa fa-flag" aria-hidden="true"></i> Report This User</a></li>
                  </ul>
                </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="tab_2" role="tabpanel" aria-labelledby="">
               <div class="row">
            <div class="col-lg-3 col-md-4 mb-4 position-relative">
                  <div
                    id="ProfileSlider"
                    class="carousel slide profile-sider"
                    data-bs-ride="carousel" data-bs-interval="false"
                  >
                    <div class="carousel-inner rounded-l cursor-pointer"  data-bs-toggle="modal" data-bs-target="#photosModal">
                      <div class="carousel-item active">
                        <img
                          src="images/profile-female-7.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-2.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                      <div class="carousel-item">
                        <img
                          src="images/profile-female-3.jpg"
                          class="photos"
                          alt="..."
                        />
                      </div>
                    </div>
                    <button
                      class="carousel-control-prev"
                      type="button"
                      data-bs-target="#ProfileSlider"
                      data-bs-slide="prev"
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button
                      class="carousel-control-next"
                      type="button"
                      data-bs-target="#ProfileSlider"
                      data-bs-slide="next"
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                  <div class="text-center my-3 carousel-counter" id="slide-counter">
                    <div class="num text-white"></div>
                  </div>
                 
                </div>
                <div class="col-lg-7 col-md-8">
                  <div class="row">
                    <div class="col-lg-6">
                        <div class="row">
                          <div class="col-6"><label for="">Registration No.</label></div>
                          <div class="col-6"><p class="font-medium">S091293821</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Surname</label></div>
                          <div class="col-6"><p class="font-medium">Shinde</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Date of Birth</label></div>
                          <div class="col-6"><p class="font-medium">11/12/1991</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Height</label></div>
                          <div class="col-6"><p class="font-medium">5’ 2”</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Education</label></div>
                          <div class="col-6"><p class="font-medium">M.COM</p></div>
                        </div>
                        
                    </div>
                    <div class="col-lg-6">
                        <div class="row">
                          <div class="col-6"><label for="">Occupation</label></div>
                          <div class="col-6"><p class="font-medium">Business</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Annual Income (Lakh)</label></div>
                          <div class="col-6"><p class="font-medium">50 Lakh</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Working city</label></div>
                          <div class="col-6"><p class="font-medium"> Pune</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Native Place</label></div>
                          <div class="col-6"><p class="font-medium"> Pune</p></div>
                        </div>
                        <div class="row">
                          <div class="col-6"><label for="">Gun Milan</label></div>
                          <div class="col-6"><p class="font-medium">24</p></div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-4 ps-md-0">
                  <button
                    type="button"
                    class="btn btn-outline-brand-1 mb-3 w-100 px-2"
                    data-bs-toggle="modal"
                    data-bs-target="#ViewContact"
                  >
                    <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                    View Contact
                  </button>
                 
                  <div class="btn-group w-100" role="group" aria-label="Basic checkbox toggle button group">
                    <input type="checkbox" class="btn-check" id="btncheck1" autocomplete="off">
                    <label class="btn btn-outline-brand-1 mb-3 w-100" for="btncheck1"><i class="fa fa-heart font-20 me-2" aria-hidden="true"></i> Shortlist</label>
                  </div>
                  <button type="button" class="btn btn-brand-1 w-100 mb-3">
                    <i
                      class="fa fa-paper-plane font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    Send interest
                  </button>
                  
                  <div class="dropdown">
                  <button type="button" class="btn btn-outline-brand-1 w-100 dropdown-toggle" id="dropdownMore"  data-bs-toggle="dropdown" aria-expanded="false">
                    <i
                      class="fa fa-ellipsis-v font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    More
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMore">
                    <li><a class="dropdown-item" href="#"><i class="fa fa-share-alt" aria-hidden="true"></i> Share Profile</a></li>
                    <li><a class="dropdown-item" href="#"><i class="fa fa-ban" aria-hidden="true"></i> Block User</a></li>
                    <li><a class="dropdown-item" href="#"><i class="fa fa-flag" aria-hidden="true"></i> Report This User</a></li>
                  </ul>
                </div>
                </div>
              </div>
            </div>
            </div>
            </div>
      </div>
      </div>
      </div>
    </main>
    
  <!-- Modal -->
<div class="modal fade" id="photosModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog photos-gallery modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header border-0 mt-3">
        <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body ">
         <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-interval="false">
  <div class="carousel-indicators">
    <button class="thumb-btn active" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1">
        <img src="images/profile-female-1.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2">
        <img src="images/profile-female-2.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3">
        <img src="images/profile-female-3.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 3">
        
        <img src="images/profile-female-4.jpg" class="thumbnail-img" alt="...">
    </button>
      <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 2">
        <img src="images/profile-female-5.jpg" class="thumbnail-img" alt="...">
    </button>
    <button class="thumb-btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 3">
        <img src="images/profile-female-6.jpg" class="thumbnail-img" alt="...">
    </button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="images/profile-female-1.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-2.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-3.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-4.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-5.jpg" class="w-100" alt="...">
    </div>
    <div class="carousel-item">
      <img src="images/profile-female-6.jpg" class="w-100" alt="...">
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
</div>
</div>
</div>
</div>
     <MainFooter />
  </div>
  <!-- photo gallery  -->


</template>
<script>
import InnerHeader from "@/components/InnerHeader";
import MainFooter from "@/components/MainFooter";
import $ from "jquery";
//import router from "../../router";
export default {
  name: "ViewedContacts",
  components: {
    InnerHeader,
    MainFooter,
  },
  data() {},
  mounted() {
     var totalItems = $('.carousel-item').length;
  var currentIndex = $('.carousel-item.active').index() + 1;
  $('.num').html('' + currentIndex + '/' + totalItems + '');

$('#ProfileSlider').bind('slid', function() {
  currentIndex = $('.carousel-item.active').index() + 1;
  $('.num').html('' + currentIndex + '/' + totalItems + '');
});
  },
  methods: {},
};
</script>
